export interface AppConfig {
  landingPage: {
    clientId: string;
    apiURL: string,
    recaptcha?: string,
    cookieYes: boolean
  }
}
